module.exports = __webpack_public_path__ + "static/media/landschaftsgrafik_man.23e6e9e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landschaftsgrafik_man.png
// module id = 1461
// module chunks = 0